import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { InputColumn } from "src/components/Inputs";
import { SelectBank } from "src/components/Selects";
import { useData } from "src/components/Table";
import { Edit, Insert } from "./Form";
import { ListButtonRow, ButtonDelete } from "src/components/Buttons";
import { deleteBank } from "src/services/api/bills";

const Units: React.FC<Props> = () => {
  const item = useData<BankValues>();
  const [selectedId, setSelectedId] = useState<number>();

  const onDelete = () => {
    if (selectedId) {
      return deleteBank(selectedId)
        .then(({ data }) => {
          item.deleted.set(item.selected.item);

          return Promise.resolve(data);
        })
        .catch(({ data }) => {
          return Promise.reject(data);
        });
    }

    return Promise.reject();
  };

  return (
    <Row>
      <Col sm={4}>
        <InputColumn label="Banco">
          <Row>
            <Col>
              <SelectBank
                onChange={value => {
                  setSelectedId(value);
                  item.selected.set(value);
                }}
                updatedItem={item.updated.item}
                deletedItem={item.deleted.item}
                newItem={item.created.item}
              />
            </Col>
          </Row>
        </InputColumn>
        <Row>
          <Col>
            <ListButtonRow
              buttonsLeft={
                <>
                  <Insert insertedItem={item.created.set} />
                  <Edit
                    item={item.selected.item!}
                    updatedItem={(value: any) => {
                      item.updated.set(value);
                      item.selected.set(undefined);
                    }}
                  />
                </>
              }
              buttonsRight={
                <ButtonDelete
                  disabled={!item.selected.item}
                  onClick={onDelete}
                />
              }
              marginTop="mt-2"
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Units;
